import { DialogContent } from '@mui/material';

import { themeColors } from 'src/theme';

import If from '../If';

import { CancelButton, ModalTitle, OkButton, ModalActions } from './components';
import { ModalProps, ModalIcons } from './modal.types';
import { StyledModal } from './Modal.styles';

import trachIcon from '../../assets/trashRedIcon.svg';
import warningIcon from '../../assets/warningOrange.svg';
import infoIcon from '../../assets/info.svg';

const themeIcons: ModalIcons = {
  delete: trachIcon,
  warning: warningIcon,
  info: infoIcon,
};

const Modal = ({
  onClose = () => {
    return undefined;
  },
  onOk,
  loading,
  children,
  title,
  subTitle,
  icon,
  cancelText,
  okText,
  theme,
  footer = ({ OkButton, CancelButton, ModalActions }) => {
    return (
      <ModalActions disableShadow>
        <CancelButton onClick={onClose} text={cancelText} />
        <OkButton
          onClick={onOk}
          loading={loading}
          sx={{
            ...(theme === 'delete' && { backgroundColor: themeColors.red, textTransform: 'unset' }),
            textTransform: 'capitalize',
          }}
          text={okText}
        />
      </ModalActions>
    );
  },
  ...props
}: ModalProps) => {
  const newIcon = icon ?? (theme ? themeIcons[theme] : undefined);
  return (
    <StyledModal onClose={onClose} aria-labelledby="customized-dialog-title" {...props}>
      <ModalTitle id="customized-dialog-title" onClose={onClose} customTitle={title} subTitle={subTitle} icon={newIcon} disableShadow />
      <If condition={!!children}>
        <DialogContent>{children}</DialogContent>
      </If>
      <If condition={!!footer}>{footer({ OkButton, CancelButton, ModalActions, destroy: onClose }) as JSX.Element}</If>
    </StyledModal>
  );
};

export default Modal;
